import { Checkbox } from '@vnetwork/ui/primitives';
import styles from './CheckboxField.module.css';

/** Checkbox with an inline label + description (the primitive is the box only). */
export function CheckboxField({
  checked,
  onChange,
  label,
  description,
}: {
  checked: boolean;
  onChange: (v: boolean) => void;
  label: string;
  description?: string;
}) {
  return (
    <label className={styles.field}>
      <Checkbox checked={checked} onCheckedChange={(c) => onChange(c === true)} />
      <div>
        <div className={styles.label}>{label}</div>
        {description && <div className={styles.desc}>{description}</div>}
      </div>
    </label>
  );
}
